import { stringifySync } from '@bingads-webui/safe-json';

import { SelectorDataSource } from './selector-data-source';

export function encodeData({ Id, Name }) {
  const newId = stringifySync({
    Id,
    Name,
  });

  return {
    Id: newId,
    Name,
  };
}

export class CampaignDataSource {
  constructor({
    dataContextManager,
    cacheService,
    jsdata,
    entitySet,
    existingCampaignFilter,
  }) {
    this.selectorDataSource = new SelectorDataSource({
      dataContextManager,
      cacheService,
      dataSource: jsdata.Campaign,
      type: 'campaign',
      selectorLoadAction: 'campaignselector/load?',
      entitySet,
      encodeData,
      where: existingCampaignFilter,
    });
  }

  get itemsDisplayLimit() {
    return this.selectorDataSource.itemsDisplayLimit;
  }

  get(viewFilter, searchFilter, ids) {
    return this.selectorDataSource.get(viewFilter, searchFilter, ids);
  }

  getByIds(ids) {
    return this.selectorDataSource.getByIds(ids);
  }
}
